module.exports = __webpack_public_path__ + "static/banner-1-b9e48b60034f7975fb7b94936dbfe218.jpg";